/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import styles from './Press.css';
import content from '../../text/press.md';
import FullWidthRegion from '../components/FullWidthRegion';

class Press extends Component {
  componentDidMount() {
    document.title = 'Press';
  }

  render() {
    return (
      <FullWidthRegion>
        <div
          styleName="press"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </FullWidthRegion>
    );
  }
}

export default CSSModules(Press, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/pages/Press.js